import * as React from 'react';

import {Button} from 'shells/button/button';
import {RadioButton} from 'shells/radio/radio-button';
import {RadioGroup} from 'shells/radio/radio-group';

// @ts-expect-error
import {JUST_THIS_AUDIENCE, ALL_AUDIENCES} from './consts';

import styles from './update-preferences.module.css';

type Props = {
    campaignName?: string;
    unsubscribeUrl?: string;
    allowAudienceUnsubscribe?: boolean;
    onSuccessfulUnsubscribe?: () => void;
};

export function UpdatePreferences(props: Props) {
    const [value, setValue] = React.useState<string>(
        !props.allowAudienceUnsubscribe ? ALL_AUDIENCES : JUST_THIS_AUDIENCE
    );

    return (
        <div className={styles.container}>
            <RadioGroup
                name='buttons'
                selectedValue={value}
                onChange={(newVal) => setValue(newVal)}
            >
                {props.allowAudienceUnsubscribe ? (
                    <RadioButton value={JUST_THIS_AUDIENCE}>
                        <div className={styles['bold-text']}>
                            Unsubscribe me from messages like this
                        </div>
                        {props.campaignName ? (
                            <div>You’ll stop receiving the {props.campaignName} newsletter</div>
                        ) : undefined}
                    </RadioButton>
                ) : null}
                <RadioButton value={ALL_AUDIENCES}>
                    <div className={styles['bold-text']}>Unsubscribe me from all emails</div>
                </RadioButton>
            </RadioGroup>
            <Button
                size='xlarge'
                variant='primary'
                isFullWidth={true}
                onClick={() => {
                    if (props.unsubscribeUrl && props.onSuccessfulUnsubscribe) {
                        Nut.ajax.post({
                            url: props.unsubscribeUrl,
                            data: {type: value},
                            success: props.onSuccessfulUnsubscribe,
                        });
                    }
                }}
            >
                Unsubscribe
            </Button>
        </div>
    );
}
